import modules_xls from './xls/index.js'
import modules_reports from './reports/index.js'
import modules_list from './list/index.js'
import modules_form from './form/index.js'
import modules_balance from './balance/index.js'
import _actions_setting_open from './_actions/setting/open.js'
import _actions_search from './_actions/search.js'
import _actions_remove from './_actions/remove.js'
import _actions_create from './_actions/create.js'
import _actions_clean from './_actions/clean.js'
import _getters_setting_opened from './_getters/setting/opened.js'
import _getters_loading from './_getters/loading.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    getters:{
        loading: _getters_loading,
        setting_opened: _getters_setting_opened,
    },
    actions:{
        clean: _actions_clean,
        create: _actions_create,
        remove: _actions_remove,
        search: _actions_search,
        setting_open: _actions_setting_open,
    },
    modules:{
        balance: modules_balance,
        form: modules_form,
        list: modules_list,
        reports: modules_reports,
        xls: modules_xls,
    },
}